import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import HomePage from './pages/HomePage'
import ServicePage from './pages/ServicePage'

/** Remount service page when slug changes so stale CMS state cannot flash. */
function ServicePageRoute() {
  const { serviceId } = useParams()
  return <ServicePage key={serviceId ?? '_'} />
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/services/ai-solution"
        element={<Navigate to="/services/ai-solutions" replace />}
      />
      <Route
        path="/services/ai-soultion"
        element={<Navigate to="/services/ai-solutions" replace />}
      />
      <Route
        path="/services/ai-tools"
        element={<Navigate to="/services/ai-solutions" replace />}
      />
      <Route
        path="/services/odoo-erp-solution"
        element={<Navigate to="/services/odoo-erp" replace />}
      />
      <Route
        path="/services/odoo-erp-soultion"
        element={<Navigate to="/services/odoo-erp" replace />}
      />
      <Route
        path="/services/odo-erp-soultion"
        element={<Navigate to="/services/odoo-erp" replace />}
      />
      <Route
        path="/services/odo-erp-solution"
        element={<Navigate to="/services/odoo-erp" replace />}
      />
      <Route path="/services/:serviceId" element={<ServicePageRoute />} />
    </Routes>
  )
}

export default App

